import { Model } from 'backbone';

// The cart item model.
const CartItemModel = Model.extend({
	defaults() {
		return {
			title: false,
			resourceId: false,
			number: false,
			language: false,
			selected: false,
			order: false,
		};
	},
	toggle() {
		this.save({ selected: !this.get('selected') });
	},
	setOrder(index) {
		this.save({ order: index });
	},
});

export default CartItemModel;
